
( function () {
   
    'use strict';

    ( function ( $ ) {
        if($('.leadership-bottom-inner').length > 0 ){
            jQuery('.leadership-image-slider-nav').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: '.leadership-text-slider-for',
                dots: false,
                arrows:false,
                cssEase: 'linear',
                focusOnSelect: true,
                adaptiveHeight: true,
                infinite: false,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: "0px",
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: "0px",
                    }

                }]
            });
            jQuery('.leadership-text-slider-for').slick({
                lazyLoad: 'progressive',
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: true,
                cssEase: 'linear',
                asNavFor: '.leadership-image-slider-nav',
                adaptiveHeight: true,
                infinite: false,
                // infinite: true,
            });           
    }
     
jQuery('.leadership-image-slider-mobile').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows:true,
    centerMode: true,
    centerPadding: "60px",
    infinite: false,
    //rtl:true,
});
jQuery('.leadership-image-slider-mobile.rtl').slick({
    slidesToShow: 1,
    slidesToScroll: -1,
    dots: false,
    arrows:true,
    centerMode: true,
    centerPadding: "60px",
    infinite: false,
    rtl: true,
});
} )( jQuery );
} )();
